import { type FC, type PropsWithChildren } from 'react'
import { useTranslation } from '../../../contexts/localization/Localization'
import { useAppContext } from '../../../contexts/AppContext'
import useScrollHighlightedIntoView from '../../../hooks/useScrollHighlightedIntoView'

const Highlighter: FC<PropsWithChildren<{ id: number }>> = ({ id, children }) => {
  const { highlightedIds } = useAppContext()
  const isHighlighted = highlightedIds.some(value => value === id)

  return (
    <div className={`relative flex`}>
      {children}
      {isHighlighted && <Frame id={id} />}
    </div>
  )
}

const Frame: FC<{
  id: number
}> = ({ id }) => {
  const { text } = useTranslation()
  const ref = useScrollHighlightedIntoView()

  return (
    <div
      ref={ref}
      data-highlighter-container
      data-testid={`highlighter_${id}`}
      className={`
            absolute h-full w-full border-solid z-1
            border-red-500 dark:border-red-900 border-b-4 border rounded-md top-0
            text-red-500 dark:text-red-900 pointer-events-none
          `}
    >
      <span className={`absolute text-[12px] right-2 bottom-0 `}>{text('questionRequiredLabel')}</span>
    </div>
  )
}
export default Highlighter
